import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil';
import { beaconSelector, mortgageSelector } from '../recoil/selector';
import useBeacon, { IClkBtnOptionProperties } from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';

export const useMtgTenant = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_TENANT,
  });
  const sendBeaconClkBtnOption = ({
    btmsheet_name,
    option_name,
    before_option_name,
  }: IClkBtnOptionProperties) => {
    beacon.sendClkBtnOption({
      properties: <IClkBtnOptionProperties>{
        btmsheet_name: btmsheet_name,
        option_name: option_name,
        before_option_name: before_option_name,
      },
    });
  };

  const sendBeaconClkBtn = (subEventName: string, props: any) => {
    beacon.sendClkBtn(
      {
        events: {
          subEventName: subEventName,
        }, 
        properties: props
      }
    );
  }

  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const [mortgageInfo] = useRecoilState(Atom.mortgageInfo);
  const [isActive, setActive] = useState<boolean>(false);

  useEffect(() => {
    if ((mortgageInfo.previousYn.value !== 'N' && (mortgageInfo.previousYn.value !== 'Y' || !mortgageInfo.previousAmt))) {
      setActive(false);
      return;
    }

    if ((mortgageInfo.tenantYn.value !== 'N' && (mortgageInfo.tenantYn.value !== 'Y' || !mortgageInfo.tenantAmt))) {
      setActive(false);
      return;
    }

    setActive(true);
    
  }, [mortgageInfo]);

  return {
    isActive,
    sendBeaconClkBtnOption,
    sendBeaconClkBtn,
  };
};
